<div class="futures-header">
  <div class="futures-avatar">{{ (Position.Customer || '?').trim().charAt(0) }}</div>
  <div class="futures-header-text">
    <div class="futures-header-top">
      <h1>{{ Position.Customer }}</h1>
      <span class="status-badge" [class.closed]="!Position.IsActive" [class.partial]="Position.PositionStatus === 'Partial'">{{ Position.PositionStatus }}</span>
      <span class="status-badge contract">{{ Position.ContractStatusName }}</span>
    </div>
    <div class="futures-header-meta">
      <span>{{ Position.Reference }}</span>
      <span>Futures: {{ Position.FuturesLabel }}</span>
      <span>Trader: {{ Position.TraderName }}</span>
      <span>FND: {{ Position.FND ? (Position.FND | date:'MM/dd/yyyy':'UTC') : '—' }}</span>
    </div>
  </div>
</div>

<div class="summary-strip">
  <div><span class="strip-label">Weight</span> {{ Position.WeightLbs | number:'1.0-0' }} lbs</div>
  <div><span class="strip-label">Contracts</span> {{ Position.Contracts | number:'1.2-2' }}</div>
  <div><span class="strip-label">Price / {{ unitLabel }}</span> {{ Position.Price != null ? (Position.Price | currency:'USD':'symbol':'1.4-4') : '—' }}</div>
  <div><span class="strip-label">Contract value</span> {{ Position.ContractValue != null ? (Position.ContractValue | currency:'USD') : '—' }}</div>
  <div><span class="strip-label">Position</span> {{ Position.PositionStatus }}</div>
</div>

@if (fndStatus === 'fnd-past') {
<div class="banner banner-error">First Notice Day has passed for this position.</div>
} @else if (fndStatus === 'fnd-warning') {
<div class="banner banner-warning">First Notice Day is in {{ Position.DaysToFND }} days (within {{ WarningDays }} days).</div>
}

<rms-tab-group>

  <rms-tab label="Overview">
    <ng-template>

      <div class="section">
        <h4>Customer</h4>
        <div class="field-grid">
          <div class="field-group span-2">
            <label>Customer</label>
            <div class="value">{{ Position.Customer }}</div>
          </div>
          <div class="field-group">
            <label>Trader</label>
            <div class="value">{{ Position.TraderName }}</div>
          </div>
          <div class="field-group">
            <label>Purchase Date</label>
            <div class="value">{{ Position.PurchaseDate ? (Position.PurchaseDate | date:'MM/dd/yyyy':'UTC') : '—' }}</div>
          </div>
        </div>
      </div>

      <div class="section">
        <h4>Futures Contract</h4>
        <div class="field-grid">
          <div class="field-group">
            <label>Futures Month</label>
            <div class="value">{{ Position.FuturesLabel }}</div>
          </div>
          <div class="field-group">
            <label>Exchange</label>
            <div class="value">{{ Position.ExchangeName ?? '—' }}</div>
          </div>
          <div class="field-group">
            <label>First Notice Day</label>
            <div class="value" [class]="fndStatus">
              {{ Position.FND ? (Position.FND | date:'MM/dd/yyyy':'UTC') : 'Not set on risk board' }}
            </div>
          </div>
          <div class="field-group">
            <label>Days Until First Notice</label>
            <div class="value" [class]="fndStatus">{{ Position.DaysToFND ?? '—' }}</div>
          </div>
          @if (isRms) {
          <div class="field-group">
            <label>Committed Weight (lbs)</label>
            <div class="value">{{ Position.OriginalWeightLbs | number:'1.0-0' }}</div>
          </div>
          <div class="field-group">
            <label>Applied to Reserves (lbs)</label>
            <div class="value">{{ Position.AllocatedWeightLbs | number:'1.0-0' }}</div>
          </div>
          <div class="field-group">
            <label>Remaining (lbs)</label>
            <div class="value">{{ Position.WeightLbs | number:'1.0-0' }}</div>
          </div>
          <div class="field-group">
            <label>Remaining Contracts</label>
            <div class="value">{{ Position.Contracts | number:'1.2-2' }}</div>
          </div>
          } @else {
          <div class="field-group">
            <label>Contracts</label>
            <div class="value">{{ Position.Contracts }}</div>
          </div>
          <div class="field-group">
            <label>Contract Weight (lbs)</label>
            <div class="value">{{ Position.WeightLbs | number:'1.0-0' }}</div>
          </div>
          <div class="field-group span-2">
            <label>Futures SKU</label>
            <div class="value">{{ Position.InventoryTypeName }}</div>
          </div>
          }
        </div>
      </div>

      <div class="section">
        <div class="section-header">
          <h4>Futures Details</h4>
          @if (isNew) {
          <span class="badge badge-new">Not tracked in RMS yet</span>
          }
        </div>
        <div class="field-grid">
          <div class="field-group">
            <label>Price Unit</label>
            <div class="value">Per {{ unitLabel }} ({{ Position.ExchangeName ?? 'exchange not set' }})</div>
          </div>
          @if (isRms) {
          <div class="field-group">
            <label>Price / {{ unitLabel }}</label>
            <input type="number" min="0" step="0.0001" [(ngModel)]="Price" [disabled]="Saving || isSigned" />
            @if (isSigned) {
            <span class="field-hint">Locked after the contract is signed.</span>
            } @else if (priceWarning) {
            <span class="field-hint fnd-warning">{{ priceWarning }}</span>
            }
          </div>
          }
          <div class="field-group">
            <label>Terminal Allocation</label>
            <select [(ngModel)]="TerminalID" [disabled]="Saving">
              <option [ngValue]="null">—</option>
              @for (t of Terminals; track t.TerminalID) {
              <option [ngValue]="t.TerminalID">{{ t.TerminalName }}</option>
              }
            </select>
            @if (legacyTerminal) {
            <span class="field-hint">Previously entered: {{ legacyTerminal }}</span>
            }
          </div>
          <div class="field-group">
            <label>Contract Status</label>
            <div class="value">{{ Position.ContractStatusName }}</div>
          </div>
          <div class="field-group">
            <label>Applied to Reserves</label>
            <div class="value">{{ Position.ApplicationDisplay }}</div>
          </div>
          <div class="field-group">
            <label>Original Weight (lbs)</label>
            <div class="value">{{ Position.OriginalWeightLbs != null ? (Position.OriginalWeightLbs | number:'1.0-0') : 'Set on first save' }}</div>
          </div>
          <div class="field-group span-4">
            <label>Contract Note</label>
            <textarea [(ngModel)]="ContractNote" maxlength="2000" rows="3" [disabled]="Saving"></textarea>
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-bg-red" (click)="resetForm()" [disabled]="Saving || !isDirty || isNew">Cancel</button>
          <button class="btn-bg-green" (click)="save()" [disabled]="Saving || !isDirty">
            {{ Saving ? 'Saving...' : (isNew ? 'Start Tracking' : 'Save') }}
          </button>
        </div>
      </div>

      @if (!isRms) {
      <div class="section">
        <h4>Reserve</h4>
        <div class="field-grid">
          <div class="field-group">
            <label>Reserve #</label>
            <div class="value">{{ Position.ReserveOrderID }}</div>
          </div>
          <div class="field-group">
            <label>Lot #</label>
            <div class="value">{{ Position.InventoryID }}</div>
          </div>
          <div class="field-group">
            <label>Contract Start</label>
            <div class="value">{{ Position.ContractStartDate ? (Position.ContractStartDate | date:'MM/dd/yyyy':'UTC') : '—' }}</div>
          </div>
          <div class="field-group">
            <label>Contract End</label>
            <div class="value">{{ Position.ContractEndDate ? (Position.ContractEndDate | date:'MM/dd/yyyy':'UTC') : '—' }}</div>
          </div>
          <div class="field-group">
            <label>Confirmation Sent</label>
            <div class="value">
              {{ Position.ConfirmSent ? 'Yes' : 'No' }}{{ Position.ConfirmSentTime ? ' · ' + (Position.ConfirmSentTime | date:'MM/dd/yyyy':'UTC') : '' }}
            </div>
          </div>
          <div class="field-group">
            <label>Created</label>
            <div class="value">{{ Position.InsertedDate ? (Position.InsertedDate | date:'MM/dd/yyyy h:mm a':'UTC') : '—' }}</div>
          </div>
        </div>
      </div>
      }

      @if (ReserveLines.length > 1) {
      <div class="section">
        <h4>All futures positions on reserve {{ Position.ReserveOrderID }}</h4>
        <rms-table [parentContext]="this"
                   [data]="ReserveLines"
                   [columns]="LineColumns"
                   tableId="futures-detail-reserve-lines"
                   startSort="FND"
                   startSortDirection="asc">
        </rms-table>
      </div>
      }

    </ng-template>
  </rms-tab>

  @if (isRms) {
  <rms-tab label="Allocations">
    <ng-template>
      <div class="summary-strip">
        <div><span class="strip-label">Committed</span> {{ Position.OriginalWeightLbs | number:'1.0-0' }} lbs</div>
        <div><span class="strip-label">Applied to reserves</span> {{ Position.AllocatedWeightLbs | number:'1.0-0' }} lbs</div>
        <div><span class="strip-label">Remaining</span> {{ remainingLbs | number:'1.0-0' }} lbs</div>
        <div><span class="strip-label">Position</span> {{ Position.PositionStatus }}</div>
      </div>

      @if (remainingLbs > 0) {
      <div class="section">
        <div class="section-header">
          <h4>Apply to Reserve</h4>
          <button class="btn-bg-blue" (click)="loadLots()" [disabled]="LoadingLots">
            {{ LoadingLots ? 'Loading lots...' : (LotsLoaded ? 'Refresh Lots' : 'Choose a Lot') }}
          </button>
        </div>
        <div class="hint">Lots in a warehouse or coming in. Free bags exclude bags already on open reserves. Click a lot to select it.</div>

        @if (LotsLoaded) {
        <div class="lots-table">
          <rms-table [parentContext]="this"
                     [data]="Lots"
                     [columns]="LotColumns"
                     [clickableRow]="true"
                     (onRowClick)="selectLot($event.row)"
                     tableId="futures-allocation-lots"
                     startSort="InventoryTypeName"
                     startSortDirection="asc">
          </rms-table>
        </div>
        }

        @if (SelectedLot) {
        <div class="selected-lot" #reserveForm>
          <div class="selected-lot-title">
            Lot {{ SelectedLot.InventoryID }} · {{ SelectedLot.InventoryTypeName }}
            <span class="badge badge-status">{{ SelectedLot.LotStatus }}</span>
          </div>
          <div class="field-grid">
            <div class="field-group">
              <label>Warehouse</label>
              <div class="value">{{ SelectedLot.WarehouseName ?? '—' }}</div>
            </div>
            <div class="field-group">
              <label>Bag Weight (lbs)</label>
              <div class="value">{{ SelectedLot.BagWeightLbs | number:'1.2-2' }}</div>
            </div>
            <div class="field-group">
              <label>Bags * (max {{ SelectedLot.MaxBags }})</label>
              <input type="number" min="1" [max]="SelectedLot.MaxBags" [(ngModel)]="AllocBags" [disabled]="Allocating" />
            </div>
            <div class="field-group">
              <label>Futures Basis / lb</label>
              <div class="value">{{ basisPerLb != null ? (basisPerLb | number:'1.4-4') : 'No contract price' }}</div>
            </div>
            <div class="field-group">
              <label>Differential / lb</label>
              <input type="number" step="0.0001" [ngModel]="AllocDiff" (ngModelChange)="AllocDiff = $event; applyDifferential()" [disabled]="Allocating" />
              <span class="field-hint">
                {{ SelectedLot.SkuDifferential != null
                  ? 'SKU ask diff ' + (SelectedLot.SkuDifferential | number:'1.2-4') + ' (SKU Pricing, ' + (SelectedLot.SkuPriceDate | date:'MM/dd/yyyy') + ')'
                  : 'No SKU differential set' }}
              </span>
            </div>
            <div class="field-group">
              <label>Reserve Price / lb *</label>
              <input type="number" min="0" step="0.0001" [(ngModel)]="AllocPrice" [disabled]="Allocating" />
              @if (calculatedPrice != null) {
              <span class="field-hint" [class.fnd-warning]="priceOverridden">
                {{ basisPerLb | number:'1.4-4' }} + {{ AllocDiff | number:'1.4-4' }} = {{ calculatedPrice | number:'1.4-4' }}{{ priceOverridden ? ' (overridden)' : '' }}
              </span>
              }
            </div>
            <div class="field-group">
              <label>Weight to Apply (lbs)</label>
              <div class="value">{{ allocWeight | number:'1.0-0' }}</div>
            </div>
            <div class="field-group">
              <label>Remaining After (lbs)</label>
              <div class="value">{{ (remainingLbs - allocWeight) | number:'1.0-0' }}</div>
            </div>
          </div>
          @if (absorbedLbs > 0 && AllocBags && SelectedLot && AllocBags <= SelectedLot.MaxBags) {
          <div class="hint">Last bag rounds up: {{ absorbedLbs | number:'1.2-2' }} lbs over the contract, absorbed by Royal. The contract will close.</div>
          }
          @if (AllocBags && SelectedLot && AllocBags > SelectedLot.MaxBags) {
          <div class="hint over-limit">Only {{ SelectedLot.MaxBags }} bags fit this lot and the contract's remaining weight.</div>
          }
          <div class="form-actions">
            <button class="btn-bg-red" (click)="SelectedLot = null" [disabled]="Allocating">Cancel</button>
            <button class="btn-bg-green" (click)="applyToReserve()" [disabled]="!canApply">
              {{ Allocating ? 'Creating reserve...' : 'Create Reserve' }}
            </button>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="hint">All of this contract's weight has been applied to reserves.</div>
      }

      <div class="section">
        <h4>Applied Reserves</h4>
        @if (Allocations.length) {
        <rms-table [parentContext]="this"
                   [data]="Allocations"
                   [columns]="AllocationColumns"
                   tableId="futures-detail-allocations"
                   startSort="CreatedDate"
                   startSortDirection="desc">
        </rms-table>
        } @else {
        <div class="hint">No reserves created from this contract yet.</div>
        }
      </div>
    </ng-template>
  </rms-tab>
  }

  <rms-tab label="Contract">
    <ng-template>
      @if (isNew) {
      <div class="hint">Click Start Tracking on the Overview tab before generating a contract.</div>
      } @else {
      <div class="section">
        <div class="section-header">
          <h4>Contract &amp; Signature</h4>
          <span class="badge badge-status">{{ Position.ContractStatusName }}</span>
        </div>
        <div class="hint">
          The contract uses the details on the Overview tab. Save any changes there before generating.
        </div>
        <div class="form-actions">
          <button class="btn-bg-blue" (click)="previewContract()" [disabled]="Generating || Previewing">
            {{ Previewing ? 'Building preview...' : 'Preview Contract' }}
          </button>
          <button class="btn-bg-green" (click)="generateContract()" [disabled]="Generating || isSigned || isDirty">
            {{ Generating ? 'Generating...' : (Documents.length ? 'Regenerate Contract' : 'Generate Contract') }}
          </button>
        </div>
        @if (isDirty) {
        <div class="hint">You have unsaved changes on the Overview tab.</div>
        }
        @if (isSigned) {
        <div class="hint">This contract is signed and can't be regenerated.</div>
        }
      </div>

      @if (latestDocument) {
      <div class="section">
        <h4>Signature</h4>
        @if (isSigned) {
        <div class="field-grid">
          <div class="field-group">
            <label>Signed On</label>
            <div class="value">{{ latestDocument.SignedDate ? (latestDocument.SignedDate | date:'MM/dd/yyyy':'UTC') : '—' }}</div>
          </div>
          <div class="field-group">
            <label>Signed Copy</label>
            <div class="value">
              @if (latestDocument.SignedFilePath) {
              <a href="javascript:void(0)" (click)="viewSignedCopy(latestDocument)">View signed copy</a>
              } @else {
              Not uploaded
              }
            </div>
          </div>
          <div class="field-group span-2">
            <label>Reason to clear signature</label>
            <input type="text" [(ngModel)]="ClearReason" maxlength="500" [disabled]="SavingSignature" placeholder="e.g. marked by mistake" />
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-bg-red" (click)="clearSignature()" [disabled]="SavingSignature || !ClearReason.trim()">Clear Signature</button>
        </div>
        } @else {
        <div class="field-grid">
          <div class="field-group">
            <label>Signed Date *</label>
            <input type="date" [(ngModel)]="SignedDate" [max]="Today" [disabled]="SavingSignature" />
          </div>
          <div class="field-group span-2">
            <label>Signed Copy (PDF, optional)</label>
            <input type="file" accept="application/pdf" (change)="onSignedFile($event)" [disabled]="SavingSignature" />
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-bg-green" (click)="markSigned()" [disabled]="SavingSignature || !SignedDate">
            {{ SavingSignature ? 'Saving...' : 'Mark v' + latestDocument.VersionNumber + ' as Signed' }}
          </button>
        </div>
        }
      </div>
      }

      <div class="section">
        <h4>Contract Versions</h4>
        @if (Documents.length) {
        <div class="hint">
          {{ Sending ? 'Sending...' : (isSigned ? 'This contract is signed, so it can no longer be sent.' : 'Use the actions to view a version or send the latest one to the customer.') }}
        </div>
        <div class="versions-table">
          <rms-table [parentContext]="this"
                     [data]="Documents"
                     [getIcons]="documentIcons"
                     ActionsText="Actions"
                     [columns]="DocumentColumns"
                     tableId="futures-detail-documents"
                     startSort="VersionNumber"
                     startSortDirection="desc">
          </rms-table>
        </div>
        } @else {
        <div class="hint">No contract generated yet.</div>
        }
      </div>
      }
    </ng-template>
  </rms-tab>

  <rms-tab label="Risk Notification">
    <ng-template>
      @if (isNew) {
      <div class="hint">Risk Management is notified when the position is first tracked. Click Start Tracking on the Overview tab.</div>
      } @else {
      <div class="section">
        <div class="section-header">
          <h4>Risk Management Notification</h4>
          @if (riskNotification) {
          <span class="badge delivery-badge delivery-{{ riskNotification.DeliveryStatus.toLowerCase() }}">{{ riskNotification.DeliveryStatus }}</span>
          } @else {
          <span class="badge badge-new">Not sent</span>
          }
        </div>
        <div class="hint">Notifications can't be deleted. Every attempt is kept in the audit trail.</div>
        <div class="form-actions">
          <button class="btn-bg-blue" (click)="notifyRisk()" [disabled]="Notifying">
            {{ Notifying ? 'Sending...' : (riskNotification ? 'Resend Notification' : 'Send Notification') }}
          </button>
        </div>
      </div>

      @if (Notifications.length) {
      <div class="section">
        <rms-table [parentContext]="this"
                   [data]="Notifications"
                   [columns]="NotificationColumns"
                   tableId="futures-detail-notifications"
                   startSort="CreatedDate"
                   startSortDirection="desc">
        </rms-table>
      </div>
      }
      }
    </ng-template>
  </rms-tab>

  <rms-tab label="Notes">
    <ng-template>
      @if (isNew) {
      <div class="hint">Click Start Tracking on the Overview tab before adding notes.</div>
      } @else {
      <div class="section">
        <h4>{{ EditingNoteID ? 'Edit Note' : 'Add Note' }}</h4>
        <div class="field-grid">
          <div class="field-group">
            <label>Note Type *</label>
            <select [(ngModel)]="NoteType" [disabled]="SavingNote">
              @for (t of NoteTypes; track t) {
              <option [ngValue]="t">{{ t }}</option>
              }
            </select>
          </div>
          <div class="field-group">
            <label>Visible To</label>
            <div class="radio-row">
              <label><input type="radio" name="visibleTo" [value]="true" [(ngModel)]="IsInternal" [disabled]="SavingNote" /> Internal only</label>
              <label><input type="radio" name="visibleTo" [value]="false" [(ngModel)]="IsInternal" [disabled]="SavingNote" /> Customer visible</label>
            </div>
          </div>
          <div class="field-group">
            <label>Related Step</label>
            <select [(ngModel)]="RelatedStep" [disabled]="SavingNote">
              <option value="">—</option>
              @for (s of RelatedSteps; track s) {
              <option [ngValue]="s">{{ s }}</option>
              }
            </select>
          </div>
          <div class="field-group">
            <label>
              <input type="checkbox" [(ngModel)]="FollowUpRequired" [disabled]="SavingNote" />
              Follow-up required
            </label>
            <input type="date" [(ngModel)]="FollowUpDate" [disabled]="SavingNote || !FollowUpRequired" />
          </div>
          <div class="field-group span-4">
            <label>Note Text *</label>
            <textarea [(ngModel)]="NoteText" maxlength="2000" rows="3" [disabled]="SavingNote"></textarea>
          </div>
        </div>
        <div class="form-actions">
          <button class="btn-bg-red" (click)="clearNote()" [disabled]="SavingNote">Clear</button>
          <button class="btn-bg-green" (click)="saveNote()" [disabled]="SavingNote">
            {{ SavingNote ? 'Saving...' : (EditingNoteID ? 'Update Note' : 'Save Note') }}
          </button>
        </div>
      </div>

      <div class="section">
        <h4>Notes History</h4>
        @if (Notes.length) {
        <div class="hint">Click a date to edit that note.</div>
        <rms-table [parentContext]="this"
                   [data]="Notes"
                   [columns]="NoteColumns"
                   tableId="futures-detail-notes"
                   startSort="CreatedDate"
                   startSortDirection="desc">
        </rms-table>
        } @else {
        <div class="hint">No notes yet.</div>
        }
      </div>
      }
    </ng-template>
  </rms-tab>

  <rms-tab label="Audit">
    <ng-template>
      @if (isNew) {
      <div class="hint">Audit history starts when the position is tracked in RMS.</div>
      } @else {
      <div class="section">
        <div class="section-header">
          <h4>Audit Trail</h4>
          <button class="btn-bg-blue" (click)="exportHistory()" [disabled]="!History.length">Export (CSV)</button>
        </div>
        <div class="hint">Audit records can't be changed or deleted.</div>
        <rms-table [parentContext]="this"
                   [data]="History"
                   [columns]="HistoryColumns"
                   tableId="futures-detail-audit"
                   startSort="ActionDate"
                   startSortDirection="desc">
        </rms-table>
      </div>
      }
    </ng-template>
  </rms-tab>

</rms-tab-group>

@if (ViewerUrl) {
<div class="pdf-backdrop" (click)="closeViewer()">
  <div class="pdf-dialog" (click)="$event.stopPropagation()">
    <div class="pdf-dialog-header">
      <h4>{{ ViewerTitle }}</h4>
      <button class="btn-bg-red" (click)="closeViewer()">Close</button>
    </div>
    <iframe class="pdf-frame" [src]="ViewerUrl" [title]="ViewerTitle"></iframe>
  </div>
</div>
}

@if (LoadingFile) {
<div class="pdf-backdrop">
  <div class="pdf-loading">Loading PDF...</div>
</div>
}
